import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row } from "react-bootstrap";
import _ from "lodash";
import ApiUserTransaction from "../../../core/api/api.userTransaction";
import { useNavigate, useLocation } from "react-router-dom";

export const ViewModal = ({
  showModalSupplierTransaction,
  setShowModalSupplierTransaction,
  selectedSupplierTransaction,
}) => {
  const handleClose = () => {
    setShowModalSupplierTransaction(false);
  };

  const checkAndShowItem = (item) => {
    if (item) return item;
    else return "---";
  };

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       if (selectedSupplierTransaction > 0) {
  //         // console.log("location.state.id ", location.state.id);
  //         // دریافت اطلاعات کاربر جهت ویرایش
  //         let response = await ApiUserTransaction.getUserTransactionById(selectedSupplierTransaction);
  //         console.log("response", response);
  //         if (response.succeeded == true) {
  //           setUserTransaction(response.data);
  //           //setValue("roleList", response.data.roleList);
  //         }
  //       }
  //     } catch (error) {
  //       console.log("error :>> ", error);
  //     }
  //   })();

  //   return () => { };
  // }, []);

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="lg" onHide={handleClose} show={showModalSupplierTransaction}>
        <Modal.Header closeButton>
          <Modal.Title>اطلاعات تراکنش </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col xs="12">
            <Row className="border-bottom mb-3">
              <h4>اطلاعات فردی</h4>

              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> تامین کننده </div>
                <div className="mt-2"> {checkAndShowItem(selectedSupplierTransaction?.supplierCompanyName)}</div>
              </Col>
              {/* <Col xs="auto">
                <div className="d-flex align-content-center justify-content-between mx-2">
                  <p>  شماره همراه  : </p>
                  <p>       {checkAndShowItem(selectedSupplierTransaction?.phoneNumber)}</p>
                </div>
              </Col> */}
            </Row>
            <Row className="border-bottom mb-3">
              <h4>اطلاعات تراکنش</h4>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> شماره تراکنش </div>
                <div className="mt-2"> {selectedSupplierTransaction?.id ? selectedSupplierTransaction.id : "---"}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> مبلغ </div>
                <div className="mt-2">
                  {selectedSupplierTransaction?.amount ? selectedSupplierTransaction.amount.toLocaleString() : "---"}
                </div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> وضعیت </div>
                <div className="mt-2">
                  {selectedSupplierTransaction?.balanceType === 1 ? "افزایش موجودی" : "کاهش موجودی"}
                </div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> تاریخ انجام </div>
                <div className="mt-2"> {checkAndShowItem(selectedSupplierTransaction?.completionDate)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> زمان انجام </div>
                <div className="mt-2"> {checkAndShowItem(selectedSupplierTransaction?.completionTime)}</div>
              </Col>
              <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                <div className="fw-bold text-muted"> کد پیگیری </div>
                <div className="mt-2"> {checkAndShowItem(selectedSupplierTransaction?.trackingCode)}</div>
              </Col>
              {selectedSupplierTransaction?.description && (
                <Col xs="12" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> توضیحات </div>
                  <div className="mt-2">{selectedSupplierTransaction?.description}</div>
                </Col>
              )}
            </Row>
            {/* {selectedSupplierTransaction?.userPayment && (
              <Row className="border-bottom mb-3">
                <Col xs="12">
                  <div className=" text-center tfont-weight-bold pb-2 mb-3">اطلاعات پرداخت</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره پرداخت </div>
                  <div className="mt-2"> {checkAndShowItem(selectedSupplierTransaction?.userPayment?.id)}</div>
                </Col>
                {selectedSupplierTransaction.riallBalance !== selectedSupplierTransaction.userPayment.rialAmount && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> مبلغ :</div>
                    <div className="mt-2">
                      {checkAndShowItem(selectedSupplierTransaction?.userPayment?.rialAmount.toLocaleString())}
                    </div>
                  </Col>
                )}
                {selectedSupplierTransaction.completionDate !== selectedSupplierTransaction.userPayment.paymentDate && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> تاریخ انجام </div>
                    <div className="mt-2">
                      {checkAndShowItem(selectedSupplierTransaction?.userPayment?.paymentDate)}
                    </div>
                  </Col>
                )}
                {selectedSupplierTransaction.completionTime !== selectedSupplierTransaction.userPayment.paymentTime && (
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> زمان انجام </div>
                    <div className="mt-2">
                      {checkAndShowItem(selectedSupplierTransaction?.userPayment?.paymentTime)}
                    </div>
                  </Col>
                )}
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره کارت پرداخت </div>
                  <div className="mt-2">
                    {checkAndShowItem(selectedSupplierTransaction?.userPayment?.cardNumberPayment)}
                  </div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره مرجع (referenceId) </div>
                  <div className="mt-2"> {checkAndShowItem(selectedSupplierTransaction?.userPayment?.referenceId)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره توکن </div>
                  <div className="mt-2" style={{ wordBreak: "break-all" }}>
                    {checkAndShowItem(selectedSupplierTransaction?.userPayment?.tokenNumber)}
                  </div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره ای پی </div>
                  <div className="mt-2" style={{ wordBreak: "break-all" }}>
                    {checkAndShowItem(selectedSupplierTransaction?.userPayment?.userIp)}
                  </div>
                </Col>
                {selectedSupplierTransaction.description !== selectedSupplierTransaction.userPayment.description && (
                  <Col xs="12" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> توضیحات </div>
                    <div className="mt-2">{selectedSupplierTransaction?.userPayment?.description}</div>
                  </Col>
                )}
              </Row>
            )} */}
            {selectedSupplierTransaction?.basket && (
              <Row className="border-bottom mb-3">
                <h4>اطلاعات سبد خرید</h4>

                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> شماره سبد </div>
                  <div className="mt-2">{checkAndShowItem(selectedSupplierTransaction?.basket?.id)}</div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> مبلغ اصلی </div>
                  <div className="mt-2">
                    {checkAndShowItem(selectedSupplierTransaction?.basket?.originalPrice.toLocaleString())}
                  </div>
                </Col>
                <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                  <div className="fw-bold text-muted"> مبلغ نهایی </div>
                  <div className="mt-2">
                    {checkAndShowItem(selectedSupplierTransaction?.basket?.price.toLocaleString())}
                  </div>
                </Col>
              </Row>
            )}
            {/* {selectedSupplierTransaction?.userWithdrawal && (
              <div>
                <Row className="border-bottom mb-3">
                  <h4>اطلاعات درخواست برداشت وجه</h4>
                  <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                    <div className="fw-bold text-muted"> شماره درخواست </div>
                    <div className="mt-2"> {checkAndShowItem(selectedSupplierTransaction?.userWithdrawal?.id)}</div>
                  </Col>
                  {selectedSupplierTransaction.riallBalance !==
                    selectedSupplierTransaction.userWithdrawal.rialAmount && (
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> مبلغ </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction?.userWithdrawal?.rialAmount.toLocaleString())}
                      </div>
                    </Col>
                  )}
                  {selectedSupplierTransaction.completionDate !==
                    selectedSupplierTransaction.userWithdrawal.paymentDate && (
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> تاریخ انجام </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction?.userWithdrawal?.paymentDate)}
                      </div>
                    </Col>
                  )}
                  {selectedSupplierTransaction.completionTime !==
                    selectedSupplierTransaction.userWithdrawal.paymentTime && (
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> زمان انجام </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction?.userWithdrawal?.paymentTime)}
                      </div>
                    </Col>
                  )}

                </Row>
                {selectedSupplierTransaction.userWithdrawal.destinationAccount && (
                  <Row className="border-bottom mb-3">
                    <h4> اطلاعات حساب مقصد </h4>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام بانک </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction.userWithdrawal.destinationAccount.bank)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(
                          selectedSupplierTransaction.userWithdrawal.destinationAccount.accountOwnerName,
                        )}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره حساب </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction.userWithdrawal.destinationAccount.accountNumber)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> نام صاحب کارت </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction.userWithdrawal.destinationAccount.cardOwnerName)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره کارت </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction.userWithdrawal.destinationAccount.cardNumber)}
                      </div>
                    </Col>
                    <Col xs="6" sm="4" lg="3" className="mt-2 mb-5">
                      <div className="fw-bold text-muted"> شماره شبا </div>
                      <div className="mt-2">
                        {checkAndShowItem(selectedSupplierTransaction.userWithdrawal.destinationAccount.shebaNumber)}
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            )} */}
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
